/**
 * Currency formatting utilities — supports TRY, USD, EUR.
 * Defaults to TRY for backwards-compat with existing UI calls.
 */

const LOCALE_BY_CURRENCY = {
  TRY: "tr-TR",
  USD: "en-US",
  EUR: "de-DE",
};

const SYMBOL_BY_CURRENCY = {
  TRY: "₺",
  USD: "$",
  EUR: "€",
};

/**
 * Format a number as money for display.
 * @param {number} amount
 * @param {string} currency - "TRY" | "USD" | "EUR"
 * @param {object} opts - { maximumFractionDigits }
 */
export function fmtMoney(amount, currency = "TRY", opts = {}) {
  const cur = (currency || "TRY").toUpperCase();
  const locale = LOCALE_BY_CURRENCY[cur] || "tr-TR";
  const fractionDigits = opts.maximumFractionDigits ?? 2;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: cur,
      maximumFractionDigits: fractionDigits,
    }).format(amount || 0);
  } catch {
    return `${(amount || 0).toFixed(fractionDigits)} ${SYMBOL_BY_CURRENCY[cur] || cur}`;
  }
}

export function currencySymbol(currency = "TRY") {
  return SYMBOL_BY_CURRENCY[(currency || "TRY").toUpperCase()] || "";
}

export const CURRENCY_OPTIONS = [
  { value: "TRY", label: "₺ Türk Lirası (TRY)" },
  { value: "USD", label: "$ ABD Doları (USD)" },
  { value: "EUR", label: "€ Euro (EUR)" },
];
